/* ============================================================================
   SECCIÓN: COLECCIÓN SIMPLE — JS OPTIMIZADO
   ============================================================================
   Archivo: section-coleccion-simple.js
   
   CAMBIO PRINCIPAL:
   ❌ Antes: DOMContentLoaded → inicia TODO de golpe (bloquea render → LCP lento)
   ✅ Ahora: IntersectionObserver → inicia cuando la sección está cerca del viewport
   
   Esto es lo que causa la "imagen gigante":
   El navegador intenta pintar pero el hilo principal está ocupado
   creando 12+ instancias de Swiper. El layout se calcula tarde
   y la imagen se muestra sin restricciones hasta que Swiper la acomoda.
   ============================================================================ */

(function () {
  "use strict";

  /* ------------------------------------------------------------------
     SLIDER PRINCIPAL
  ------------------------------------------------------------------ */
  function initSimpleProductSlider(root) {
    root.querySelectorAll(":scope .slider-simple").forEach(function (sl) {
      if (sl.dataset.inited) return;
      sl.dataset.inited = "true";

      new Swiper(sl, {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: 1,
        breakpoints: {
          700: { slidesPerView: 3 }
        },
        scrollbar: {
          el: sl.querySelector(".swiper-scrollbar"),
          draggable: true
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     INIT COMPLETO — se llama solo cuando la sección es VISIBLE
  ------------------------------------------------------------------ */
  function initSection(root) {
    if (root.dataset.sectionInited) return;
    root.dataset.sectionInited = "true";

    initSimpleProductSlider(root);
    initGallerySlider(root);  // del helpers (ahora con IO interno)
    initVariantSystem(root);  // del helpers (ahora con delegación)
    initAddToCart(root);       // del helpers (ahora con delegación)
  }

  /* ------------------------------------------------------------------
     LAZY INIT — la sección NO se toca hasta que esté cerca
  ------------------------------------------------------------------ */
  function setupLazyInit() {
    var sections = document.querySelectorAll(
      '[data-section-type="coleccion-simple"]'
    );
    if (!sections.length) return;

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            obs.unobserve(entries[i].target);
            initSection(entries[i].target);
          }
        },
        { rootMargin: "300px" }
      );

      sections.forEach(function (s) {
        observer.observe(s);
      });
    } else {
      sections.forEach(initSection);
    }
  }

  /* ------------------------------------------------------------------
     EVENTOS
  ------------------------------------------------------------------ */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupLazyInit);
  } else {
    setupLazyInit();
  }

  // Editor de Shopify
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target;
    if (
      !root ||
      !root.matches('[data-section-type="coleccion-simple"]')
    )
      return;
    root.dataset.sectionInited = "";
    initSection(root);
  });
})();